import SignupCompo from '../features/Auth/components/SignupCompo'
import { GoogleOAuthProvider } from '@react-oauth/google';

function SignupPage() {
    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <SignupCompo />
        </GoogleOAuthProvider>
    );
}

export default SignupPage;